import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PaginatedResponse } from '../../../../shared/interfaces/pagination';
import { Observable } from 'rxjs';
import { LeadStatusLog } from '../models/lead-status';
import { LeadStatusCount } from '../../../dashboard/models/lead-status-count';

@Injectable({
  providedIn: 'root',
})
export class LeadStatusService {
  private http: HttpClient = inject(HttpClient);

  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getLeadStatusLogs(
    pageNo = 1,
    pageSize = 10,
    connectionId?: number,
    status?: number,
    searchParam?: string,
  ): Observable<PaginatedResponse<LeadStatusLog>> {
    let params = new HttpParams();
    params = params.set('page', pageNo.toString());
    params = params.set('page_size', pageSize.toString());

    if (searchParam) {
      params = params.set('business_name', searchParam.toString());
    }

    if (status !== undefined) {
      params = params.set('status', status);
    }

    if (connectionId !== undefined) {
      params = params.set('connection_id', connectionId);
    }

    return this.http.get<PaginatedResponse<LeadStatusLog>>(
      this.adminApiBaseUrl + '/lead-status',
      { params },
    );
  }

  getLeadsStatusCounts(
    connectionId?: number,
    status?: number,
  ): Observable<LeadStatusCount[]> {
    let params = new HttpParams();
    if (connectionId !== undefined) {
      params = params.set('connection_id', connectionId);
    }
    if (status !== undefined) {
      params = params.set('status', status);
    }

    return this.http.get<LeadStatusCount[]>(
      this.adminApiBaseUrl + '/lead-status/count',
      { params },
    );
  }
}
